import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import Api from "./Api";
import { notificacoesApiConfig } from "./config";
import { UploadDTO } from "@/models/administracao/comunicacao/UploadDTO";

// @ts-ignore
import _ from 'lodash';

class NotificacoesApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  listarTemplates(): Promise<any[]> {
    return this.get(`/comunicacao/templates`);
  }

  recuperarConfiguracaoVariaveis(idTemplate: number): Promise<any[]> {
    return this.get(`/comunicacao/parametros/${idTemplate}`);
  }

  executarConsultar(parametros: any): Promise<any> {
    return this.post<any>("/comunicacao/executar-consultar", parametros)
    .catch((error: AxiosError) => {
      if (!error.response?.data.isAutorizado) {
        throw new Error(error.response?.data.message);
      } else {
        throw new Error("Falha ao realizar consulta");
      }
    });
  }

  efetuarDisparo(parametros: any): Promise<any> {
    return this.post<any>("/comunicacao/realizar-disparo", parametros)
    .catch((error: AxiosError) => {
      if (!error.response?.data.isAutorizado) {
        throw new Error(error.response?.data.message);
      } else {
        throw new Error("Falha ao realizar disparo");
      }
    });
  }

  

  listarGatilhos(): Promise<any[]> {
    return this.get(`/comunicacao/gatilhos`);
  }

  salvarTemplate(payload: UploadDTO): Promise<any> {
      return this.post<any>("/comunicacao/salvar", payload);
  }

  validarSql(payload: any): Promise<any> {
    return this.post<any>("/comunicacao/validar-consulta", payload);
  }

  downloadTemplate(id: number): Promise<any> {
    return this.get(`/comunicacao/template/download/${id}`);
  }

  excluirTemplate(id: number) {
    return this.delete(`/comunicacao/template/excluir/${id}`).catch(() => {
      throw new Error("Falha ao excluir template.");
    });
  }

  relatorioDisparo(payload: any): Promise<any> {
    return this.post<any>("/comunicacao/relatorio-disparos", payload);
  }

  gerarRelatorioAssociadosInativos(tipo: string, filtro: any
    ): Promise<any> {
      return this.post<any>(
        tipo.toLocaleLowerCase() === 'pdf' ? "/comunicacao/relatorio-disparos/pdf" : '/comunicacao/relatorio-disparos/xls',
        filtro,
        {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/pdf",
          },
        }
      );
  }

  inativarTemplate(id: number): Promise<any> {
    return this.put(`/comunicacao/template/inativar/${id}`);
  }

  ativarTemplate(id: number): Promise<any> {
    return this.put(`/comunicacao/template/ativar/${id}`);
  }
}

export const notificacoesApi = new NotificacoesApi(
  notificacoesApiConfig
);
